import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulldog',
  templateUrl: './bulldog.component.html',
  styleUrls: ['./bulldog.component.css']
})
export class BulldogComponent implements OnInit {

  photos: [];

  constructor() { }

  ngOnInit(): void {

    const count: number = this.getRandomInt(100);

    fetch('https://dog.ceo/api/breed/bulldog/images/random/' + count)
      .then(response => response.json())
      .then(json => {
        console.log(json);
        this.photos = json.message;
      });

  }
  getRandomInt(max: number): number {
    return Math.floor(Math.random() * Math.floor(max));
  }
}
